import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Button from '@mui/material/Button';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { getLinkLtik } from 'constants/LTIData';

import classes from './BtnsLessons.module.css';

const url = window.location.pathname.split('/');

const BtnsLessons = props => {
  const dataCourse = useSelector(state => state.courseInfo);
  const { t } = useTranslation(['lesson']);
  const [prevLesson, setPrevLesson] = useState(null);
  const [nextLesson, setNextLesson] = useState(null);

  useEffect(() => {
    let prevFlag = false;
    let currentPrevLesson = null;
    let nextFlag = false;
    let currentNextLesson = null;
    let checkLesson = false;

    if (dataCourse.lessonsCourse.sizeSeparators >= 0) {
      if (dataCourse.lessonsCourse.separators.length > 0) {
        dataCourse.lessonsCourse.separators.map(separador => {
          separador.lessons.map(videosCount => {
            if (prevFlag == true) {
              return false;
            }
            currentPrevLesson = videosCount.idVideo;
            if (props.idLesson == currentPrevLesson) {
              prevFlag = true;
              return false;
            }
            setPrevLesson(videosCount.idVideo);
          });
        });

        dataCourse.lessonsCourse.separators.map(separador => {
          separador.lessons.map(videosCount => {
            if (nextFlag == true) {
              return false;
            }
            currentNextLesson = videosCount.idVideo;
            if (checkLesson == true) {
              setNextLesson(videosCount.idVideo);
              nextFlag = true;
              return false;
            }
            if (props.idLesson == currentNextLesson) {
              checkLesson = true;
            }
          });
        });
      } else {
        dataCourse.lessonsCourse.lessons.map(videosCount => {
          if (prevFlag == true) {
            return false;
          }
          currentPrevLesson = videosCount.idVideo;
          if (props.idLesson == currentPrevLesson) {
            prevFlag = true;
            return false;
          }
          setPrevLesson(videosCount.idVideo);
        });
        dataCourse.lessonsCourse.lessons.map(videosCount => {
          if (nextFlag == true) {
            return false;
          }
          currentNextLesson = videosCount.idVideo;
          if (checkLesson == true) {
            setNextLesson(videosCount.idVideo);
            nextFlag = true;
            return false;
          }
          if (props.idLesson == currentNextLesson) {
            checkLesson = true;
          }
        });
      }
    }
  }, [dataCourse.lessonsCourse]);

  const changeLessonHandler = () => {
    props.loadLesson();
  };

  return (
    <div className={classes.btnsLessonsContainer}>
      {prevLesson !== null && (
        <>
          <Button
            onClick={changeLessonHandler}
            className={classes.button}
            component={Link}
            to={
              getLinkLtik()
                ? `/${
                    url[3] === 'aud' || url[2] === 'aud'
                      ? 'aud'
                      : 'f'
                  }/${
                    props.idCourse
                  }/${prevLesson}/?ltik=${getLinkLtik()}`
                : url[2] === 'a'
                ? `/a/${
                    url[3] === 'aud' || url[2] === 'aud'
                      ? 'aud'
                      : 'f'
                  }/${props.idCourse}/${prevLesson}`
                : url[2] === 'course'
                ? `/course/${
                    url[3] === 'aud' || url[2] === 'aud'
                      ? 'aud'
                      : 'f'
                  }/${props.idCourse}/${prevLesson}`
                : `/${
                    url[3] === 'aud' || url[2] === 'aud'
                      ? 'aud'
                      : 'f'
                  }/${props.idCourse}/${prevLesson}`
            }
          >
            <ChevronLeftIcon />
            {t('previous')}
          </Button>
        </>
      )}
      {nextLesson !== null && (
        <>
          <Button
            onClick={changeLessonHandler}
            className={classes.button}
            component={Link}
            to={
              getLinkLtik()
                ? `/${
                    url[3] === 'aud' || url[2] === 'aud'
                      ? 'aud'
                      : 'f'
                  }/${
                    props.idCourse
                  }/${nextLesson}/?ltik=${getLinkLtik()}`
                : url[2] === 'a'
                ? `/a/${
                    url[3] === 'aud' || url[2] === 'aud'
                      ? 'aud'
                      : 'f'
                  }/${props.idCourse}/${nextLesson}`
                : url[2] === 'course'
                ? `/course/${
                    url[3] === 'aud' || url[2] === 'aud'
                      ? 'aud'
                      : 'f'
                  }/${props.idCourse}/${nextLesson}`
                : `/${
                    url[3] === 'aud' || url[2] === 'aud'
                      ? 'aud'
                      : 'f'
                  }/${props.idCourse}/${nextLesson}`
            }
          >
            {t('next')}
            <ChevronRightIcon />
          </Button>
        </>
      )}
    </div>
  );
};

BtnsLessons.propTypes = {
  // eslint-disable-next-line react/require-default-props
  lessonData: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  idLesson: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  idCourse: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  loadLesson: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  format: PropTypes.string
};

export default BtnsLessons;
